import React from 'react';
import {Xmark} from '@gravity-ui/icons';

import './KeyboardCloseButton.scss';

interface KeyboardCloseButtonProps {
    onClose?: () => void;
    className?: string;
}

export const KeyboardCloseButton: React.FC<KeyboardCloseButtonProps> = ({onClose, className}) => {
    return (
        <button
            type="button"
            className={['keyboard-close-button', className].filter(Boolean).join(' ')}
            aria-label="Закрыть"
            onClick={() => onClose?.()}
        >
            <Xmark />
        </button>
    );
};
